import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans } from 'react-i18next';
import { Button } from 'next-common-lib';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import { PORTAL_MAIN_URL_FREE_ADD, TERMS_TYPE, DRIVE_URL_CONFIG } from 'constants/IncorporationConstants';
import * as employeeActions from 'redux/ducks/Employee/EmployeeDucks';

export const AdminCompletion = ({ svcType }) => {
  const dispatch = useDispatch();
  const { employeeVo, driveDomain } = useSelector(state => state.employee);
  const getAdminTitle = () => {
    let getComponent = '';
    switch (svcType) {
      case TERMS_TYPE.MESSENGER:
        getComponent = (
          <>
            <p className="title">
              <Trans i18nKey="MB_T_FREEMIUM_RESULT_TITLE_BASIC" />
            </p>
            <p className="text">
              <Trans i18nKey="MB_T_FREEMIUM_RESULT_INFO_BASIC" />
            </p>
          </>
        );
        break;
      case TERMS_TYPE.MEETING:
        getComponent = (
          <>
            <p className="title">
              <Trans i18nKey="MB_T_FREEMIUM_RESULT_TITLE_BASIC" />
            </p>
            <p className="text">
              <Trans i18nKey="MB_T_FREEMIUM_MT_RESULT_INFO_BASIC" />
            </p>
          </>
        );
        break;
      case TERMS_TYPE.PORTAL:
        getComponent = (
          <>
            <p className="title">
              <Trans i18nKey="MB_T_FREEMIUM_RESULT_TITLE_BASIC" />
            </p>
            <p className="text">
              <Trans i18nKey="MB_T_FREEMIUM_PT_RESULT_INFO_BASIC" />
            </p>
          </>
        );
        break;
      case TERMS_TYPE.DRIVE:
        getComponent = (
          <>
            <p className="title">{i18n.t('MB_T_FREEMIUM_DV_RESULT_TITLE_BASIC')}</p>
            <p className="text">
              <Trans i18nKey="MB_T_FREEMIUM_DV_RESULT_INFO_BASIC" />
            </p>
          </>
        );
        break;
      default:
        break;
    }
    return getComponent;
  };

  const getButton = () => {
    let buttonComponent = '';
    switch (svcType) {
      case TERMS_TYPE.MESSENGER:
        buttonComponent = (
          <Button
            componentType="solid"
            className="primary "
            label={i18n.t('MB_T_FREEMIUM_INVITE_USER')}
            onClick={() => {
              window.location.href = PORTAL_MAIN_URL_FREE_ADD;
            }}
          />
        );
        break;
      case TERMS_TYPE.MEETING:
        buttonComponent = (
          <Button
            componentType="solid"
            className="primary "
            label={i18n.t('MB_T_FREEMIUM_INVITE_USER_MT')}
            onClick={() => {
              window.location.href = PORTAL_MAIN_URL_FREE_ADD;
            }}
          />
        );
        break;
      case TERMS_TYPE.DRIVE:
        buttonComponent = (
          <Button
            componentType="solid"
            className="primary "
            label={i18n.t('MB_T_FREEMIUM_INVITE_USER_DV')}
            onClick={() => {
              window.location.href = driveDomain;
            }}
          />
        );
        break;
      case TERMS_TYPE.PORTAL:
        buttonComponent = (
          <Button
            componentType="solid"
            className="primary "
            label={i18n.t('MB_T_FREEMIUM_INVITE_USER_PT')}
            onClick={() => {
              window.location.href = PORTAL_MAIN_URL_FREE_ADD;
            }}
          />
        );
        break;
      default:
        break;
    }
    return buttonComponent;
  };
  const getContactUs = () => {
    const handleContactUs = e => {
      e.preventDefault();
      const recipient = 'brityworks.sales@samsung.com';
      window.location.href = `mailto:${recipient}`;
    };
    return (
      <div className="contact_text">
        <div>
          <Trans i18nKey={i18n.t('MB_T_CONTACT_US_AFTER_SIGN_UP')} />
        </div>
        <div style={{ height: '18px' }}>
          <span className="blue mail" style={{ cursor: 'pointer' }} onClick={handleContactUs}>
            <div className="icon_container">
              <i className="ic_letter" />
            </div>
            brityworks.sales@samsung.com
          </span>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (svcType === TERMS_TYPE.DRIVE) {
      dispatch(employeeActions.getDriveDomain(DRIVE_URL_CONFIG));
    }
  }, [svcType]);

  return (
    <div className="brity-container freetrial-area">
      <div className="brity-contents">
        <div className="brity-content-area">
          <div className="freetrial-area">
            <div className="freetrial-content-area">
              <div className="freetrial-content">{getAdminTitle()}</div>
              {svcType === 'PT' && getContactUs()}
              <ul className="freetrial-box">
                <li>
                  <p className="title">{i18n.t('MB_T_FREEMIUM_COMPANY')}</p>
                  <p className="text">{employeeVo.compNm}</p>
                </li>
                <li>
                  <p className="title">{i18n.t('MB_T_FREEMIUM_USER_ID')}</p>
                  <p className="text">{employeeVo.userId}</p>
                </li>
                <li>
                  <p className="title">{i18n.t('MB_T_FREEMIUM_NAME')}</p>
                  <p className="text">{employeeVo.fnm}</p>
                </li>
              </ul>
              {getButton()}
            </div>
            <div className="freetrial-notice-area">
              <div className="tip-box">
                <div className="tip-box-text">
                  <p className="text">{i18n.t('MB_T_FREEMIUM_CONTACT_CENTER_1')}</p>
                  <p className="number">{i18n.t('MB_T_FREEMIUM_CONTACT_CENTER_2')}</p>
                </div>
                <div className="tip-box-img">
                  <i className="ic-call xl" />
                </div>
              </div>
              <ul className="freetrial-notice">
                <li>
                  <p className="text">{i18n.t('MB_T_FREEMIUM_RESULT_SPEC_1')}</p>
                </li>
                <li>
                  <p className="text">{i18n.t('MB_T_FREEMIUM_RESULT_SPEC_2')}</p>
                </li>
                <li>
                  <p className="text">{i18n.t('MB_T_FREEMIUM_RESULT_SPEC_3')}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
AdminCompletion.propTypes = { svcType: PropTypes.string };
AdminCompletion.defaultProps = { svcType: null };
export default AdminCompletion;
